<body id="cj-product" class="">
  <div class="cj-reduction cj-red-1">
    <div class="circle-bg"></div>
    <header class="seges" *ngIf="isSegurosUser">
      <div class="container-header">
        <a href="https://www.seguros.es" target="_blank" class="logo"><img src="https://www.seguros.es/wp-content/themes/seges/assets/img/logo-seguros-es.svg" width="157" height="28" alt="Logo seguros.es"></a>
      </div>
    </header>
    <div class="container">
      <app-header></app-header>
      <div class="row row-flex" id="userProfile">
        <div class="cj-landing-row">
          <!-- Header Logo -->
          <div class="cj-landing-header">
            <div class="cj-header-logo">
              <div class="header-logo-section">
                <img src="{{ baseImageUrl }}cj/health.svg" class="head-ras-icon" />
                <img src="{{ baseImageUrl }}cj/health-wl.svg" class="head-ras-icon-wl" />
                <h1 class="cj-header-title">Calcular seguro de salud</h1>
              </div>
              <div class="header-logo-sub-section"><strong>Déjate </strong><span>ayudar</span></div>
            </div>
            <div app-banner class="cj-header-usp hidden-xs"></div>
          </div>

          <div class="flex-column">
            <!-- Header Progress Bar -->

            <header id="cj-header" class="is-landing">
              <div class="container">
                <div class="row">
                  <div class="col-xs-12">
                    <div class="cj-progress-bar is-landing">
                      <ul>
                        <li class="activeli" id="li-firstSection" [class.completed]="isLastPage">
                          <div class="circle"><span class="number">Paso 1</span><i class="icon icon-check"></i></div>
                          <div class="progress" [ngStyle]="{ width: !isLastPage ? 'calc(80% + 20px)' : '' }"></div>
                        </li>
                        <li id="li-secondSection" [class.activeli]="isLastPage">
                          <div class="circle"><span class="number">Paso 2</span><i class="icon icon-check"></i></div>
                          <div class="progress" [ngStyle]="{ width: isLastPage ? 'calc(60% + 20px)' : '' }"></div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </header>

            <router-outlet></router-outlet>
          </div>

          <div app-banner class="cj-header-usp visible-xs"></div>
        </div>
      </div>
      <div class="row row-flex" id="seotext" [ngStyle]="{ display: isLastPage ? 'none' : 'block' }">
        <div class="col-xs-12">
          <div seo-text></div>
        </div>
      </div>
    </div>
  </div>

  <ras-ayuda-box></ras-ayuda-box>
  <footer app-footer style="margin-bottom: -20px"></footer>
  <ras-recaptchav3></ras-recaptchav3>
</body>
